import { MixpanelTracker } from '@stilingue/st-analytics';
import { isNotRunningLocally } from '@stilingue/st-environment-controller-utils';

let mixPanelIntance;

export const insertMixpanelPlugin = (user, activeCompany) => {
  mixPanelIntance = new MixpanelTracker({
    user: {
      id: user.id,
      email: user.email,
    },
    peopleData: {
      admin: user.admin,
      avatarUrl: user.avatarUrl,
      createdAt: user.createdAt,
      initialPasswordChanged: user.initialPasswordChanged,
      intercomHash: user.intercomHash,
      master: user.master,
      userName: user.name,
      paymentKind: user.paymentKind,
      roleId: user.roleId,
      userGroup: activeCompany,
      $name: user.name,
      $email: user.email,
    },
    config: {
      token: process.env.VUE_APP_MIXPANEL_API,
      name: process.env.NODE_ENV,
    },
  });
};

export const trackEvent = (eventName, properties) => {
  if (isNotRunningLocally()) {
    mixPanelIntance.track(eventName, properties);
    return;
  }

  const makeTableProperties = (properties) => {
    const objectKeys = Object.keys(properties);
    objectKeys.forEach(key => {
      if (typeof properties[key] === 'object') {
        console.info(`%c${key}`, 'font-weight:bold');
        console.table(properties[key]);
        delete properties[key];
      }
    });

    console.table(properties);
  };

  console.groupCollapsed(`%c${eventName}`, 'color:#4f44e0');
  properties ? makeTableProperties(properties) : console.info('no properties');
  console.groupEnd();
};

export const getMixpanelInstance = () => mixPanelIntance.mixpanelInstace();
